import {
  EVENT_TYPE_CONSULTATION,
  EVENT_TYPE_SCREENING,
  EVENT_TYPE_THERAPY_SESSION,
} from 'src/consumer/constants'

export function getEmrReportTypeBasedOnEventType(eventType) {
  switch (eventType) {
    case EVENT_TYPE_CONSULTATION:
      return 'prescription'
    case EVENT_TYPE_SCREENING:
      return 'screening-report'
    case EVENT_TYPE_THERAPY_SESSION:
      return 'therapy-report'
    default:
      return null
  }
}
